import cookie from 'react-cookie';
import moment from 'moment';
import 'moment-timezone';
import React from 'react';
import _ from 'lodash';

import AltIso from 'alt/utils/AltIso';
import connectToStores from 'alt/utils/connectToStores';

import HiringActions from '../actions/HiringActions';
import SeoActions from '../actions/SeoActions';

import CandidateStore from '../stores/CandidateStore';
import ChatMessageIsReadStore from '../stores/ChatMessageIsReadStore';
import ChatStore from '../stores/ChatStore';
import CurrentUserStore from '../stores/CurrentUserStore';
import HiringStore from '../stores/HiringStore';
import ShiftStore from '../stores/ShiftStore';
import PositionStore from '../stores/PositionStore';

import DetailsShiftModal from '../components/DetailsShiftModal';
import LoadingView from '../components/LoadingView';
import OffersHeader from '../components/OffersHeader';

import doRedirect from '../utils/doRedirect';
import imgResolver from '../utils/img-resolver';
import reportTime from '../utils/reportTime';
import withRouter from '../utils/with-router';


@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Offers');
            resolve();
        })
    ]);
})

@connectToStores
@withRouter
class DashboardProOffers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            day: moment().startOf('day'),
            shiftsPerPage: 100,
            isLoading: false,
            hiringCreated: false,
            messageSent: false,
            toggleFilters: false,
            dates: null,
            reloadShifts: false

        };

        if (!cookie.load('filters')) {
            const query = `?start_time=${moment().format("YYYY-MM-DD")}&page_size=${this.state.shiftsPerPage}`;
            ShiftStore.getProShifts(query)
        }
        ShiftStore.getMaxRate();
        PositionStore.getPositions();
    }

    componentDidMount() {
        if (!this.props.user.profile.profile.is_candidate) {
            setTimeout((x) => {doRedirect(this.context.router, 'completeprofile')}, 50);
        } else {
            CandidateStore.getCandidate(this.props.user.profile.profile.candidate_id);
        }
    }

    static getPropsFromStores() {
        return {
            shiftStore: ShiftStore.getState(),
            positionStore: PositionStore.getState(),
            hiringStore: HiringStore.getState(),
            chatStore: ChatStore.getState(),
            chatMessageIsReadStore: ChatMessageIsReadStore.getState(),
            candidateStore: CandidateStore.getState(),
            currentUserStore: CurrentUserStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore, PositionStore, HiringStore, ChatStore, ChatMessageIsReadStore, CandidateStore];
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.hiringStore.hiringError && nextProps.hiringStore.hiringError && Object.keys(nextProps.hiringStore.hiringError).length) {
            this.toggleShiftModal();
            this.setState({reloadShifts: true});
        }

        if (!this.props.chatStore.sendMessageError && nextProps.chatStore.sendMessageError && Object.keys(nextProps.chatStore.sendMessageError).length) {
            this.toggleShiftModal();
            this.setState({reloadShifts: true});
        }

        if (this.state.activeShift && ((nextProps.hiringStore.created !== this.state.hiringCreated) || this.props.hiringStore.deleted !== nextProps.hiringStore.deleted)) {
            const activeShift = this.state.activeShift;
            activeShift.hiring = nextProps.hiringStore.hiring;
            this.setState({activeShift, hiringCreated: nextProps.hiringStore.created, isLoading: false});
        }

        if (this.state.activeShift && nextProps.chatStore.messageSent !== this.state.messageSent) {
            const shiftId = this.state.activeShift.id;
            this.setState({messageSent: nextProps.chatStore.messageSent, isLoading: false});
            ChatStore.getMessages({shift: shiftId, user: this.props.user.profile.profile.id});
        }
    }

    filterShifts(query) {
        ShiftStore.getProShifts(`${query}&page_size=${this.state.shiftsPerPage}`);
    }

    filterLocations(query, positions, start_time, end_time) {
        ShiftStore.getLocations({query, positions, start_time, end_time});
    }

    calendarOnChange(dates) {
        const candidateId = this.props.candidateStore.curCandidate.id;
        this.setState(dates);
        CandidateStore.updateCandidateDates({ignored_dates: dates.dates}, candidateId);
    }

    applyForShift() {
        const shiftId = this.state.activeShift.id;
        this.setState({isLoading: true});
        HiringStore.createHiring(shiftId);
    }

    cancelHiring() {
        const shiftId = this.state.activeShift.id;
        const hiringId = this.state.activeShift.hiring.id;
        const userId = this.props.user.profile.profile.id;
        HiringStore.deleteHiring(hiringId, shiftId, userId).then((resolve) => {
            HiringActions.resetDeleted();
        });
    }

    getShifts(next_page) {
        if (next_page !== null) {
            ShiftStore.loadMoreProShifts(next_page);
        }
    }

    renderCurrentShifts(shifts) {
        let cur_shifts = [];
        shifts.forEach(shift => {
            const price = shift.hiring && shift.hiring.price ? shift.hiring.price : shift.rate;
            const isSeen = cookie.load('seenShifts') && cookie.load('seenShifts').split(',').map((x) => {return parseInt(x)}).indexOf(shift.id) !== -1;
            const start_time = moment(shift.start_time).tz(shift.company.timezone);
            const end_time = moment(shift.end_time).tz(shift.company.timezone);
            const time = reportTime(start_time, end_time);
            const isNew = moment(this.props.user.profile.profile.last_login) < moment(shift.created_at) && !isSeen;
            const labelText = shift.hiring ? 'APPLIED' : null;
            let newLabel, label;

            if (isNew && !labelText) {
                newLabel = <div className="new">NEW</div>;
            }

            if (labelText) {
                label = <div className="applied">{labelText}</div>;
            }

            cur_shifts.push(
                <li onClick={this.toggleShiftModal.bind(this, shift)} className="event" key={shift.id}>
                    <h3 className="title">{shift.position.name}</h3>
                    <p className="location">{shift.venue}</p>

                    <p className="pinpoint">{shift.city + ', ' + shift.country}</p>
                    <p className="rate">{DJ_CONST.LOCALE_CONF.currency}{price} / h - total: {DJ_CONST.LOCALE_CONF.currency}{shift.total_pay}</p>
                    <p className="date">{time}</p>
                    <p className="company">{shift.company.name}</p>

                    <div className="statuses">
                        {newLabel}
                        {label}
                        {shift.message_count ? <div className="comments">{shift.message_count}</div> : ''}
                    </div>
                </li>
            );
        });

        return cur_shifts;
    }

    renderShifts(shiftsToRender) {
        let dates = _.uniq(_.map(shiftsToRender, (shift) => {return moment(shift.start_date).tz(shift.company.timezone).format('dddd D.MMM');}));
        if (shiftsToRender.length > 0) {
            let shifts = [];
            dates.forEach(date => {
                const shifts_for_date = _.filter(shiftsToRender, shift => { return moment(shift.start_date).tz(shift.company.timezone).format('dddd D.MMM') === date; });
                shifts.push(
                    <ul className="day">
                        <h3 className="date">{date}</h3>
                        {this.renderCurrentShifts(shifts_for_date)}
                    </ul>
                );
            });
            return shifts;
        } else if (this.props.shiftStore.proShiftsLoaded) {
            return (
                <div className="empty-offers">
                    <img src={require('../styles/images/offers-image.png')} />
                    <div className="header">We didn't find anything</div>
                    <div className="content">Your search filters might be too strict</div>
                    <button onClick={this.toggleFilters.bind(this)} className="btn btn-green">Edit filters</button>
                </div>
            );
        } else {
            return (<LoadingView />);
        }
    }

    toggleFilters() {
        this.setState({toggleFilters: !this.state.toggleFilters});
    }

    sendMessage(data) {
        this.setState({isLoading: true});
        ChatStore.sendMessage(data);
    }

    toggleShiftModal(activeShift=null) {
        if (activeShift) {
            let seenShifts = cookie.load('seenShifts') || '';
            if (seenShifts.split(',').map((x) => {return parseInt(x)}).indexOf(activeShift.id) == -1) {
                seenShifts = `${seenShifts},${activeShift.id}`;
                cookie.save('seenShifts', seenShifts);
            }
            ChatStore.getMessages({'shift': activeShift.id, 'user': this.props.user.profile.profile.id})
        }
        setTimeout(HiringActions.resetCreated, 500);
        this.setState({showShiftModal: !this.state.showShiftModal, activeShift, hiringCreated: false, isLoading: false});
    }

    makeMessagesRead() {
        const shift = this.state.activeShift;
        if (shift.hiring) {
            ChatMessageIsReadStore.create(shift.message_count, shift.hiring.id);
        }
        shift.message_count = 0;
    }

    getIgnoredDates(candidate) {
        let ignoredDates = this.state.dates;
        if (candidate.ignored_dates && ignoredDates === null) {
            ignoredDates = candidate.ignored_dates;
        }
        if (ignoredDates) {
            ignoredDates = ignoredDates.split('|').slice(1);
        }
        return ignoredDates
    }

    render () {
        const candidate = this.props.candidateStore.curCandidate;
        const max_rate = Math.ceil(parseFloat(this.props.shiftStore.max_rate) || 100);
        const searchResults = this.props.shiftStore.searchResults;
        const nextPage = this.props.shiftStore.next_page;
        const showShiftModal = this.state.showShiftModal;
        const activeShift = this.state.activeShift;
        const isLoading = this.state.isLoading;
        const hiringCreated = this.state.hiringCreated;
        const chatMessages = this.props.chatStore.messages || [];
        const messageSent = this.state.messageSent;
        const toggleFilters = this.state.toggleFilters;
        const reloadShifts = this.state.reloadShifts;

        if (!Object.keys(candidate).length) {
            return (<LoadingView />);
        }

        let ignoredDates = this.getIgnoredDates(candidate) || [];
        const shiftsToRender = this.props.shiftStore.shifts_pro.filter(shift => {
            const start_date = moment(shift.start_date).tz(shift.company.timezone).format("YYYY-MM-DD");
            return shift.hiring != null || ignoredDates.indexOf(start_date) < 0;
        });

        return (
            <div className="view-offers">
                <OffersHeader
                    ref="offersHeader"
                    dates={candidate.ignored_dates}
                    count={shiftsToRender.length}
                    max_rate={max_rate}
                    professions={candidate.professions}
                    filterShifts={this.filterShifts.bind(this)}
                    filterLocations={this.filterLocations.bind(this)}
                    searchResults={searchResults}
                    calendarOnChange={this.calendarOnChange.bind(this)}
                    toggleFilters={toggleFilters}
                    candidate={candidate}
                    reloadShifts={reloadShifts}
                    resetReloadShifts={this.setState.bind(this, {reloadShifts: false})} />

                <div className="view-content maxwidth-wrapper">

                    <div className="offers">
                            {this.renderShifts(shiftsToRender)}
                    </div>
                    {(nextPage ? <button onClick={() => this.getShifts(nextPage)} className="btn btn-bordered">Load more offers</button> : null)}

                </div>

                <DetailsShiftModal toggleModal={this.toggleShiftModal.bind(this)}
                            isVisible={showShiftModal} shift={activeShift}
                            applyForShift={this.applyForShift.bind(this)}
                            cancelHiring={this.cancelHiring.bind(this)}
                            isLoading={isLoading}
                            hiringCreated={hiringCreated}
                            messages={chatMessages}
                            messageSent={messageSent}
                            user={this.props.user.profile}
                            sendMessage={this.sendMessage.bind(this)}
                            makeMessagesRead={this.makeMessagesRead.bind(this)} />
            </div>
        );
    }
}

export default DashboardProOffers;



/** WEBPACK FOOTER **
 ** ./app/src/views/DashboardProOffers.js
 **/